<template>
  <RouterView />
</template>

<script setup>
import { useTokenStore } from '@/stores'
import { getHttpsAddress } from '@/utils/index'

const { setToken, setRefreshtoken } = useTokenStore()

onMounted(() => {
  // 获取网址中的token参数的值
  const token = new URL(window.location.href).searchParams.get('token')
  const refreshtoken = new URL(window.location.href).searchParams.get('refreshtoken')

  getHttpsAddress()

  // const token =
  //   'eyJhbGciOiJIUzUxMiJ9.eyJ1c2VySnNvbiI6IntcImlkXCI6NDAsXCJwbGF0Zm9ybUNvbnN0YW50XCI6XCJXRUNIQVRfUFJPR1JBTVwiLFwiZXhwaXJlc0F0XCI6MTc2NjQ5NjI3MTk1MixcInJlbWVtYmVyXCI6dHJ1ZX0iLCJleHAiOjE3NjY0OTYyNzF9.Ef-EQYhBQ75WmnbA_OZodw9xByI8V8FWCtinMrk7hVxk5JdEu4V2r7JiVH4jygHXjSQDgHw8NemlUvj00SFgHQ'
  // const refreshtoken = 'feca5cdbb9448e752a73f7632b3b6b8e'
  if (token) {
    // 存储token
    localStorage.setItem('userToken', JSON.stringify({ token, refreshtoken }))
    setToken(token)
    setRefreshtoken(refreshtoken)
  }
})
</script>

<style scoped lang="scss"></style>
